import React, { useState } from 'react';
import ErrorCorrectionExercise from './ErrorCorrectionExercise';
import './ErrorCorrectionExerciseBoard.css';

const ERROR_CORRECTION_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)', marginRight: 20
  }}>
    <svg fill="none" width="26" height="26" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path clipRule="evenodd" d="m19 3h-14c-1.65686 0-3 1.34315-3 3v12c0 1.6569 1.34315 3 3 3h14c1.6569 0 3-1.3431 3-3v-12c0-1.65685-1.3431-3-3-3zm-15 3c0-.55228.44772-1 1-1h14c.5523 0 1 .44772 1 1v12c0 .5523-.4477 1-1 1h-14c-.55228 0-1-.4477-1-1zm1.38906 8.143h1.816v.388c0 .3975.31355.711.711.711.39389 0 .718-.31.718-.711v-.388h.059c.35125 0 .641-.2744.641-.634 0-.3555-.28554-.641-.641-.641h-.059v-2.334c0-.401-.32411-.711-.718-.711-.18711 0-.3409.0382-.48004.12074-.13304.07896-.24021.19166-.34412.31346l-2.12739 2.4703-.0007.0008c-.17777.2087-.29975.4283-.29975.7177 0 .4115.34218.697.725.697zm1.816-1.275h-.66845l.66845-.7835zm4.78814 2.416c1.451 0 2.384-1.2369 2.384-2.734v-.014c0-1.4977-.9335-2.72-2.37-2.72-1.4435 0-2.38397 1.2365-2.38397 2.734v.014c0 1.4968.91877 2.72 2.36997 2.72zm.014-1.373c-.2481 0-.4599-.1235-.6174-.3565-.1604-.2372-.2606-.5856-.2606-1.0045v-.014c0-.4195.0987-.7642.2563-.9976.1544-.2288.3625-.3494.6077-.3494.2435 0 .4557.1241.6149.3593.1616.2386.2631.5872.2631 1.0017v.014c0 .4164-.0971.7613-.254.9956-.1537.2294-.3615.3514-.61.3514zm3.3213.232h1.816v.388c0 .3975.3136.711.711.711.3939 0 .718-.31.718-.711v-.388h.059c.3513 0 .641-.2744.641-.634 0-.3555-.2855-.641-.641-.641h-.059v-2.334c0-.401-.3241-.711-.718-.711-.1871 0-.3409.0382-.48.12074-.1331.07896-.2402.19166-.3442.31346l-2.1273 2.4703-.0007.0008c-.1778.2087-.2998.4283-.2998.7177 0 .4115.3422.697.725.697zm1.816-1.275h-.6684l.6684-.7835zm-12.1445-5.868c0-.55228.44772-1 1-1s1 .44772 1 1-.44772 1-1 1-1-.44772-1-1zm4-1c-.55228 0-1 .44772-1 1s.44772 1 1 1 1-.44772 1-1-.44772-1-1-1z" fill="white" fillRule="evenodd"/>
    </svg>
  </span>
);

const ErrorCorrectionExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { sentences, title, level } = exerciseData;

  if (!sentences || !Array.isArray(sentences)) {
    return (
      <div className="error-correction-board-error">
        <p>Error: Invalid Error Correction exercise data</p>
      </div>
    );
  }

  return (
    <div className="error-correction-exercise-board">
      {!isExpanded ? (
        <div
          className={`error-correction-preview unified-exercise-preview ec-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={() => {
            if (isExpandedProp === undefined) setIsExpandedLocal(true);
            if (onSelect) onSelect();
            if (onExpand) onExpand();
          }}
        >
          {ERROR_CORRECTION_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Error Correction Exercise'}</div>
            <div className="unified-preview-meta">
              {sentences.length} sentences · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="error-correction-expanded">
          <ErrorCorrectionExercise
            sentences={sentences}
            title={title}
            level={level}
            onClose={() => { if (isExpandedProp === undefined) setIsExpandedLocal(false); if (onClose) onClose(); }}
            onUpdate={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default ErrorCorrectionExerciseBoard; 